import { render, staticRenderFns } from "./UserReviews.vue?vue&type=template&id=70f59bf4&scoped=true&"
import script from "./UserReviews.vue?vue&type=script&lang=js&"
export * from "./UserReviews.vue?vue&type=script&lang=js&"
import style0 from "./UserReviews.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./UserReviews.vue?vue&type=style&index=1&id=70f59bf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f59bf4",
  null
  
)

export default component.exports